<template>
  <!-- 账号管理设置页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
      <config-hang @click.native="deviceSet('changeRemark')">
        <span slot="config_hang_ele2">修改设备备注</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
      <config-hang @click.native="deviceSet('changeAddress')">
        <span slot="config_hang_ele2">修改设备地址</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
    </div>
  </div>
</template>

<script>
import configHang from "components/common/config/config-hang";

export default {
  data() {
    return {
      query: {}
    };
  },
  components: {
    configHang
  },
  methods: {
    deviceSet(type) {
      this.query.type = this.query.type + type;
      this.$router.push({
        path: "thirdPanelInfoManage",
        query: this.query
      });
    }
  },
  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
    this.query = this.$route.query;
    console.log(this.query);
  }
};
</script>

<style>
.device_go_online_btn_corol {
  color: var(--primary-color);
}
</style>
